console.log('[Accordion Check] Script caricato correttamente');

document.addEventListener("DOMContentLoaded", function () {
  // Selettori che vogliamo gestire
  const accordions = document.querySelectorAll('.accordion-item, .product__block--collapsible_tab');
  
  accordions.forEach(item => {
    const title = item.querySelector('h2');
    const content = item.querySelector('.accordion-details__content');

    if ((!title || title.textContent.trim() === '') || (!content || content.textContent.trim() === '')) {
      console.log('[Accordion Check] Nascondo un accordion perché il titolo o il contenuto sono vuoti');
      item.style.display = 'none';
    }
  });
});
